import { TableBody } from '@material-ui/core';

import { Row } from '@/components/modules/Reports/ReportDetails/ReportPayoutsTable/components/Row';
import { ReportPayoutsTableProps } from '@/components/modules/Reports/ReportDetails/ReportPayoutsTable/ReportPayoutsTable';
import { DefaultTableProps } from '@/types/defaultTableProps';

export interface BodyProps extends ReportPayoutsTableProps {
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
}

export const Body = ({ report, tableProps }: BodyProps) => {
  return (
    <>
      <TableBody>
        {report.payouts.map((payout) => {
          return <Row key={payout.id} payout={payout} tableProps={tableProps} />;
        })}
      </TableBody>
    </>
  );
};
